<template>
  <div>

    <div
      v-show="contentShow"
      class="login-background"
    />

  </div>
</template>

<script>

export default {
  name: 'Login',
  components: { },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },

  mounted() {
    // this.loading = false
  },

  created() {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
